import { Alert } from 'reactstrap';
import './index.scss';

export const TipAlert = ({
    containerClassName = '', className = '', label, tipText = 'Tip', color = 'warning',
}) => (
    <div className={containerClassName}>
        <Alert
            className="tip-alert"
            color={color}
        >
            <small className={className}>
                {Boolean(tipText) && (
                    <>
                        <span className="tip-text">{tipText}</span>
                        <span>{': '}</span>
                    </>
                )}

                {label}
            </small>
        </Alert>
    </div>
);